module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-3000-Classes-Active-d0bedcf07184a51e6eb2d1cf648e159e.png";